import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { logToApi } from './api';  // Asegúrate de importar tu función para crear logs en la API
import './components/Global/Style/Global.css';

window.onerror = async (message, source, lineno, colno, error) => {
  // Crear el log de error
  const log = {
    logLevel: 'Error',
    message: message || 'Error no manejado',
    exception: (error && error.stack) ? error.stack : '',
    userId: null,  // Puedes agregar el ID del usuario si es necesario
    source: `${source}:${lineno}:${colno}`,  // Agrega la ubicación del error
    application: 'FRONT',
    httpMethod: '',  // No es relevante aquí
    path: window.location.pathname,  // Ruta actual donde ocurrió el error
    controller: '',
    action: '',
    requestBody: '',
    statusCode: 500,
    durationMs: 0,
    ipAddress: '',  // Dirección IP, si la tienes
  };

  try {
    await logToApi(log);  // Intentar enviar el log al servidor
    console.error('Error capturado y enviado al servidor:', log);
  } catch (apiError) {
    console.error('Error al enviar el log al servidor:', apiError);
  }
};

// Función global de manejo de errores no manejados
window.addEventListener('unhandledrejection', handleUnhandledRejection);

// Función que maneja los errores no gestionados
async function handleUnhandledRejection(event) {
  const { reason, promise } = event;

  // Crear el log de error
  const log = {
    logLevel: 'Error',
    message: (reason && reason.message) ? reason.message : 'Error no manejado',
    exception: (reason && reason.stack) ? reason.stack : '',
    userId: null,  // O toma el ID del usuario si es necesario
    source: getErrorSource(reason),  // Aquí agregamos la fuente del error
    application: 'FRONT',
    httpMethod: '',  // No aplicable aquí
    path: window.location.pathname,
    controller: '',
    action: '',
    requestBody: '',
    statusCode: 500,
    durationMs: 0,
    ipAddress: '',  // Dirección IP si es necesario
  };

  try {
    await logToApi(log);  // Intentar enviar el log al servidor
    console.error('Error no manejado enviado al servidor:', log);
  } catch (apiError) {
    console.error('Error al enviar el log al servidor:', apiError);
  } 
}

// Función para obtener el origen del error desde la pila de errores
function getErrorSource(error) {
  if (error && error.stack) {
    const stackLines = error.stack.split('\n');
    const sourceLine = stackLines[1] || ''; // Segunda línea normalmente contiene el origen
    const source = sourceLine.match(/at (.*)/);  // Captura la función o archivo

    if (source && source[1]) {
      return source[1];  // Retorna el origen del error
    }
  }

  return 'Unknown source';  // Si no se puede obtener el origen
}

ReactDOM.render(
  <AuthProvider>
    <App />
  </AuthProvider>,
  document.getElementById('root')
);
